//https://www.sitepoint.com/throttle-scroll-events/
const throttle = (fn, wait) => {
	let time = Date.now();
	return (e) => {
		if ((time + wait - Date.now()) < 0) {
			fn(e);
			time = Date.now();
		}
	}
};

export default throttle;



// WEBPACK FOOTER //
// ./src/helpers/throttle.js